import type { ReferenceItem } from '@/components/references/ReferenceListItem.vue';

/**
 * Generate BibTeX entries for a list of references.
 */
export function toBibTeX(refs: ReferenceItem[]): string {
    return refs
        .map((ref) => {
            const authors = Array.isArray(ref.authors)
                ? ref.authors
                : [ref.authors ?? ''];
            const authorStr = authors.join(' and ');
            const year = ref.year ?? '';
            const doi = ref.doi ?? '';

            let entry = `@article{${ref.key},\n`;
            entry += `  title = {${escapeBibTeX(ref.title)}},\n`;
            entry += `  author = {${escapeBibTeX(authorStr)}},\n`;

            if (year) {
                entry += `  year = {${year}},\n`;
            }

            if (doi) {
                entry += `  doi = {${doi}},\n`;
            }

            entry += `}`;

            return entry;
        })
        .join('\n\n');
}

/**
 * Trigger a .bib file download for the given references.
 */
export function downloadBibTeX(
    refs: ReferenceItem[],
    projectName: string,
): void {
    const content = toBibTeX(refs);
    const blob = new Blob([content], { type: 'text/plain;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${slugify(projectName)}.bib`;
    a.click();
    URL.revokeObjectURL(url);
}

function escapeBibTeX(text: string): string {
    return text.replace(/[{}\\]/g, (c) => `\\${c}`);
}

function slugify(text: string): string {
    return text
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')
        .substring(0, 60);
}
